// utils/assetDisposal.js
//
// Disposal details captured when an asset is discarded (PUT
// /products/:id/discard). Mirrors the backend rule in
// validators/productLifecycleValidator.js#validateDisposalPayload, which
// stays the authority:
//   * Disposal Method is required;
//   * Auction Date is required for AUCTION, and never before Purchase Date;
//   * Auction / Sale Amount is optional, zero or more (blank = 0).
// Shared by pages/technicians/ProductUnitWisePage.js and
// pages/admins/inventroy/InventoryProductList.js so both forms agree.
import { toDateOnlyString } from "./dateOnly";

export const DISPOSAL_METHODS = [
  ["AUCTION", "Auction"],
  ["SALE", "Sale"],
  ["SCRAP", "Scrap"],
  ["DONATION", "Donation"],
  ["WRITE_OFF", "Write-off"],
  ["OTHER", "Other"],
];

export const BLANK_DISPOSAL = { disposal_method: "", auction_date: "", disposal_amount: "" };

// purchaseDate: the asset's own purchase date as the API sent it -- read as
// its calendar day (utils/dateOnly), never by slicing a UTC timestamp.
export function validateDisposalForm(form, { purchaseDate } = {}) {
  if (!form.disposal_method) return "Disposal Method is required";
  if (form.disposal_method === "AUCTION" && !form.auction_date) {
    return "Auction Date is required when the Disposal Method is Auction";
  }
  const purchase = toDateOnlyString(purchaseDate);
  if (form.auction_date && purchase && form.auction_date < purchase) {
    return "Auction Date cannot be before the asset's Purchase Date";
  }
  if (String(form.disposal_amount ?? "").trim() !== "") {
    const n = Number(form.disposal_amount);
    if (!Number.isFinite(n) || n < 0) return "Auction / Sale Amount must be zero or a positive number";
  }
  return null;
}

export function disposalPayload(form) {
  const amount = String(form.disposal_amount ?? "").trim();
  return {
    disposal_method: form.disposal_method,
    auction_date: form.auction_date || null,
    disposal_amount: amount === "" ? 0 : Number(amount),
  };
}

export const disposalMethodLabel = (value) =>
  (DISPOSAL_METHODS.find(([v]) => v === value) || [null, value || "—"])[1];
